import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../../Context/CartContext';
import '../Styles/cartItems.css';
import allImages from '../Assets/allImages';
import { RiDeleteBin5Line } from "react-icons/ri";
import { useAuth } from '../../Context/AuthContext';
import { Link } from 'react-router-dom';

function CartItems() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { cart, cartItems, removeFromCart, updateQuantity, stockError, setStockError } = useCart();
  const [deliveryMode, setDeliveryMode] = useState('standard');
  const [orderSummary, setOrderSummary] = useState(null);

  const [promoInput, setPromoInput] = useState('');
  const [promoCode, setPromoCode] = useState('');

  useEffect(() => {
  if (cartItems.length === 0) {
    setOrderSummary(null);
    return;
  }

  async function fetchSummary() {
    const response = await fetch('/api/calculate_order.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ids: cartItems,
        deliveryMode: deliveryMode,
        promoCode: promoCode
      })
    });

    const data = await response.json();
    setOrderSummary(data);
  }

  fetchSummary();
}, [cartItems, promoCode, deliveryMode]);

  const totalArticles = Array.isArray(cartItems) 
  ? cartItems.reduce((acc, item) => acc + item.quantity, 0)
  : 0;

  
  const formatQuantity = (poids, unite) => {
    const poidsNum = parseFloat(poids);
    if (isNaN(poidsNum)) return '';

    if (unite === 'g') {
      return poidsNum >= 1000
        ? `${(poidsNum / 1000).toFixed(1)}kg`
        : `${poidsNum}g`;
    }
    return `${poidsNum}`;
  };

  const handlePaiement = () => {
    if (!user) {
      alert("Vous devez être connecté pour passer commande.");
      navigate('/login');
      return;
    }
    navigate('/checkout', { state: { promoCode } });
  };

  return (
    <div>
      <h2 className='cart-h2'>Votre Panier</h2>

      <div className="cart-container">
        {Array.isArray(cartItems) && cartItems.length === 0 ? (
          <p>Votre panier est vide.</p>
        ) : (
          <div className="info-paiement">
            {stockError && (
              <div className="custom-alert">
                {stockError}
                <button onClick={() => setStockError(null)}>X</button>
              </div>
            )}
            <div className="recap-cart">
              {cartItems && Array.isArray(cartItems) && cartItems.map(item => (
                <div className="cartitems-container" key={`${item.id}-${item.poids}-${item.gout}`}>
                  <Link to={`/produit/${item.product_id}`}>
                    <img src={`/static/media/${item.image}`} alt={item.nom} className="img-cart" />
                  </Link>

                  <div className="cartitems-infos">
                    <Link to={`/produit/${item.product_id}`}>
                      <div className="cartitems-title">{item.nom}</div>
                    </Link>

                    <div className="cartitems-info-produit">
                      {item.gout && <div className="cartitems-gout">Saveur : {item.gout}</div>}
                      <div className="cartitems-format">Format : {formatQuantity(item.poids, item.unite)}</div>
                    </div>

                    <div className="cartitems-prix">{Number(item.price ?? 0).toFixed(2)} €</div>
                  </div>
                  <div className="qte">
                    <button className='btn-qte' onClick={() => updateQuantity(item.variante_option_id, Number(item.quantity) - 1)}  disabled={Number(item.quantity) <= 1}>-</button>
                    <span className="nb-qte">{item.quantity}</span>
                    <button className='btn-qte' onClick={() => updateQuantity(item.variante_option_id, Number(item.quantity) + 1)}>+</button>
                  </div>
                  <div className="total-price">{(Number(item.quantity ?? 0) * Number(item.price ?? 0)).toFixed(2)} €</div>
                  <button onClick={() => removeFromCart(item.variante_option_id)}>
                    <RiDeleteBin5Line size={20} cursor="pointer" />
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}
      <div className="info-articles">
        <div className="code-promo-container">
          <p className="title-promo">Un code promo ?</p>
          <div className="code-promo">
            <input className='code-promo-input' type="text" placeholder='Entrer votre code' value={promoInput} onChange={(e) => setPromoInput(e.target.value)}/>
            <button
              className='validation-btn'
              onClick={(e) => {
                e.preventDefault();
                setPromoCode(promoInput);
              }}
            >
              Valider
            </button>
          </div>
        </div>

        <div className="total-price-container">
          <p className="tp-title">Récapitulatif</p>
          <div className="tp-articles-container">
            <p className="tp-articles">Articles :</p>
            <p className="tp-nb-articles">{totalArticles}</p>
          </div>
          <div className="tp-remise-container">
            <p className="tp-remise">Remise :</p>
            <p className="tp-remise-price">
              {orderSummary?.remise > 0
                ? `- ${orderSummary.remise.toFixed(2)} €`
              : 'Aucune'}
            </p>
          </div>
          <div className="commander">
            <h3>Total : {orderSummary?.totalFinal?.toFixed(2) || "0.00"} €</h3>
            <div className="commander-btn">
              <button className="btn" onClick={handlePaiement}>Commander</button>
            </div>
          </div>
        </div>

        <div className="offres">
          <div className="offres-livraison">Livraison offerte dès 40€</div>
        </div>
      </div>
    </div>
      </div>
      
  );
}

export default CartItems;